import { LocationProducts, ServiceAndLocation } from '@voice/utils';

export interface Step {
  key: string;
  title: string;
  description?: string;
  icon: string;
  touched?: boolean;
  /** true = complete (green), false = invalid (red), 'partial' = in progress (amber), undefined = neutral */
  valid?: boolean | 'partial';
  disabled?: boolean;
}

export enum StepKey {
  CUSTOMER = 'customer',
  LOCATIONS = 'locations',
  SERVICES = 'services',
  ITEMS = 'items',
  SUMMARY = 'summary',
}

export function allLocationsAreValid(locations: ServiceAndLocation[]): boolean {
  if (locations && locations.length > 0) {
    let result = true;
    for (const location of locations) {
      if (
        !isValidValue(location.firstName) ||
        !isValidValue(location.lastName) ||
        !isValidValue(location.companyName) ||
        !isValidValue(location.addressLine1) ||
        !isValidValue(location.state) ||
        !isValidValue(location.city) ||
        !isValidValue(location.zipCode)
      ) {
        result = false;
        break;
      }
    }
    return result;
  }
  return false;
}

export function allServicesAreValid(locations: ServiceAndLocation[]): boolean {
  if (locations && locations.length > 0) {
    let result = true;
    for (const location of locations) {
      if (
        !isValidValue(location.serviceType) ||
        !isValidValue(location.provider)
      ) {
        result = false;
        break;
      }
    }
    return result;
  }
  return false;
}

export function allProductsAreValid(items: LocationProducts[]): boolean {
  if (items && items.length > 0) {
    let result = true;
    for (const item of items) {
      if (
        !isValidValue(item.location) ||
        !item.products ||
        item.products.length === 0
      ) {
        result = false;
        break;
      }
    }
    return result;
  }
  return false;
}

function isValidValue(value?: string): boolean {
  return value !== undefined && value !== null && value.trim().length > 0;
}
